








import { Prop, Component, Vue } from 'vue-property-decorator'

@Component
export default class IconLow extends Vue {
    @Prop({ type: Number, default: 48 }) readonly size!: number
}
